import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import _ from 'lodash';
import DropdownIcon from 'components/DropdownIcon';
import {
  OVERLAY_SHOW_SEASONS_TAB,
  OVERLAY_SHOW_CLIPS_TAB,
  OVERLAY_SHOW_MORE_TAB,
} from 'helpers/FilterHelper';
import { getUrlTarget, LABEL_CLIPS_AND_EXTRAS, LABEL_CLIPS } from 'helpers/ContentHelper';
import Dropdown from 'components/Dropdown';
import dropdownHeaderStyle from './DropdownHeader.module.scss';
import {
  scrollToElement,
  clearFetchNodeInterval,
  checkForDOMNode,
} from '../../SeriesDetailHelpers';

import Style from './TabListMobile.module.scss';

class TabListMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moreTabItems: {
        items: [],
      },
      clippedTabItems: {},
      // currentFetchNode is used in checkForDOMNode and clearFetchNodeInterval
      // eslint-disable-next-line react/no-unused-state
      currentFetchNode: null,
    };
    this.checkForDOMNode = checkForDOMNode.bind(this);
    this.clearFetchNodeInterval = clearFetchNodeInterval.bind(this);
    this.detectClipping = this.detectClipping.bind(this);
  }

  getClipping() {
    const { clippedTabItems } = this.state;
    return _.some(clippedTabItems, item => item);
  }

  getSelectedDropdownItem = () => selected => {
    scrollToElement({
      slug: `${_.kebabCase(selected)}`,
      nodeFetcher: this.checkForDOMNode,
      duration: 10000,
      clearNodeFetcher: this.clearFetchNodeInterval,
      offsetTop: 250,
    });
  };

  closeAllDropdowns = () => {
    const { setOverlay } = this.props;
    const dropdowns = [OVERLAY_SHOW_SEASONS_TAB, OVERLAY_SHOW_CLIPS_TAB, OVERLAY_SHOW_MORE_TAB];
    _.each(dropdowns, dropdown => setOverlay(dropdown, false));
  };

  closeDropdown = overlay => () => {
    const { setOverlay } = this.props;
    return setOverlay(overlay, false);
  };

  detectClipping = (tabTitle, isVisible) => {
    const newClipping = !isVisible;
    const { clippedTabItems, moreTabItems } = this.state;
    const clippedTabItem = _.get(clippedTabItems, tabTitle);
    if (clippedTabItem !== newClipping) {
      this.setState(
        {
          clippedTabItems: {
            ...clippedTabItems,
            [_.camelCase(tabTitle)]: newClipping,
          },
        },
        () => {
          this.closeAllDropdowns();
          if (newClipping) {
            this.setState({
              moreTabItems: {
                items: _.uniqBy([...moreTabItems.items, ...this[tabTitle].props.items], 'id'),
              },
            });
          } else {
            this.setState({
              moreTabItems: {
                items: _.uniq(_.dropRight(moreTabItems.items, 1)),
              },
            });
          }
        },
      );
    }
  };

  handleGroupName = group => {
    const groupNames = {
      playlist: 'Clips',
    };

    return groupNames[group];
  };

  handleTabNameParsing = tabName => {
    const { seriesDetail_castHeader: castTitle } = window.Language;
    if (tabName) {
      if (tabName.indexOf('Season') > -1) {
        return 'seasons';
      }

      if (tabName === castTitle) {
        return 'Cast';
      }
    }

    return tabName;
  };

  handleTabTypeParsing = tab => {
    if (_.get(tab, 'onClick')) {
      return 'tabs';
    }

    return 'links';
  };

  openDropdown = overlay => () => {
    const { setOverlay } = this.props;
    return setOverlay(overlay, true);
  };

  openSubmenu = group => {
    const { setOverlay } = this.props;
    const overlayGroup = {
      playlist: OVERLAY_SHOW_CLIPS_TAB,
    };

    setOverlay(overlayGroup[group], true);
  };

  createTabs(tab, isMoreTab) {
    if (_.isEmpty(tab)) return null;
    const {
      moreTabItems: { items: moreItems },
    } = this.state;
    const { tabs, pageId, isPersonality } = this.props;
    const { items } = tab;
    const title = isMoreTab ? 'more' : _.camelCase(tab.name);
    const type = _.get(tab, 'type');
    const changeCb = isVisible => {
      this.detectClipping(title, isVisible);
    };
    const selectedItem = _.find(items, ({ linkTo }) => _.includes(linkTo, pageId));
    const isActive = pageId
      ? Boolean(selectedItem)
      : title === 'seasons' || tabs.length === 1 || isPersonality;
    const defaultTitle = _.get(items, '0.parentName');
    const hideTab = !!_.find(moreItems, item => _.camelCase(item.name) === title);
    const containerClass = hideTab ? dropdownHeaderStyle.hidden : null;
    const renderedTab =
      (type === 'links' || items.length === 1) && !isMoreTab
        ? this.renderLink(tab, isActive, containerClass)
        : this.renderDropdown({ items, title, isMoreTab, isActive, defaultTitle, containerClass });
    const offset = { right: 30 };
    if (!_.isEmpty(moreItems)) offset.right = 110;

    if (isPersonality) return renderedTab;

    return (
      <VisibilitySensor
        ref={el => {
          this[title] = el;
        }}
        key={title + _.get(tab, 'id')}
        offset={offset}
        onChange={changeCb}
        delayedCall
        resizeCheck
        active={title !== 'more'}
        items={items}
      >
        {renderedTab}
      </VisibilitySensor>
    );
  }

  transformTabs(items) {
    const { isPersonality } = this.props;
    return _.reduce(
      items,
      (acc, tab) => {
        const { name: tabName, parentName } = tab;
        const name = this.handleTabNameParsing(parentName || tabName);
        const type = this.handleTabTypeParsing(tab);

        if (isPersonality) {
          if (!acc.tabs.all) {
            acc.tabs.all = { name };
            acc.tabs.all.type = type;
            acc.tabs.all.items = [tab];
          } else {
            acc.tabs.all.items.push(tab);
          }
          return acc;
        }

        if (!acc.tabs[name]) {
          acc.tabs[name] = { name };
          acc.tabs[name].type = type;
          acc.tabs[name].items = [];
        }

        if (name === 'Cast') {
          _.assign(tab, {
            name,
          });
        }

        if (name === 'clips') {
          acc.tabs.clips.items.push({
            ..._.get(tab, 'tab'),
            linkTo: tab.linkTo,
            labelDetail: `(${tab.tab.items.totalItems})`,
            group: 'playlist',
          });
        } else {
          acc.tabs[name].items.push(tab);
        }

        return acc;
      },
      {
        tabs: {},
        more: {
          name: 'more',
          type: 'tabs',
          items: [],
        },
      },
    );
  }

  renderCurrentDropdowns() {
    const { tabs } = this.props;
    const tabItems = this.transformTabs(tabs).tabs;
    return _.map(tabItems, tabItem => this.createTabs(tabItem));
  }

  renderDropdown({ items, title, isMoreTab, isActive, defaultTitle, containerClass }) {
    const { overlay, tabs, tabIndex } = this.props;
    const overlayType = {
      seasons: OVERLAY_SHOW_SEASONS_TAB,
      clips: OVERLAY_SHOW_CLIPS_TAB,
      more: OVERLAY_SHOW_MORE_TAB,
    };
    if (!_.get(overlayType, title)) overlayType[title] = `overlay-${title}`;
    const dropdownOpen = overlay === _.get(overlayType, title);
    let selected = _.get(tabs, `${tabIndex}.name`);
    const dropdownSelected = !!_.find(items, item => {
      const lowerSelected = selected ? selected.toLowerCase() : null;
      const lowerName = item && item.name ? item.name.toLowerCase() : null;
      return lowerSelected && lowerName && lowerSelected === lowerName;
    });
    if (!dropdownSelected) selected = null;
    const styleName = _.some(items, 'tab.headline') ? 'select' : title;
    return (
      <Dropdown
        className={containerClass}
        items={items}
        defaultText={isMoreTab ? _.capitalize(title) : defaultTitle || _.capitalize(title)}
        expandedHeaderCopy={dropdownHeaderStyle[styleName]}
        getIcon={onClick => <DropdownIcon onClick={onClick} opened={dropdownOpen} />}
        onOpenDropdown={this.openDropdown(overlayType[title])}
        onCloseDropdown={this.closeDropdown(overlayType[title])}
        expanded={dropdownOpen}
        theme={dropdownHeaderStyle}
        getSelected={this.getSelectedDropdownItem()}
        selected={selected}
        preserveTitle={isMoreTab}
        useLabelDetail={title === 'clips'}
        openSubmenu={this.openSubmenu}
        displayResults
        showMobileCancel
        isActive={isActive}
        getUrlTarget={getUrlTarget}
      />
    );
  }

  renderLink = (tab, isActive, containerClass) => {
    const link = _.first(tab.items);
    const { name, linkTo } = link;
    const { target, rel } = getUrlTarget(linkTo);
    return (
      <div
        className={classNames(
          dropdownHeaderStyle.header,
          dropdownHeaderStyle.container,
          containerClass,
        )}
      >
        <Link
          to={linkTo}
          target={target}
          rel={rel}
          className={Style.mobileExternalLink}
          style={isActive ? { color: 'white' } : {}}
        >
          {name === LABEL_CLIPS_AND_EXTRAS ? LABEL_CLIPS : name}
        </Link>
      </div>
    );
  };

  renderMoreDropdown() {
    const { moreTabItems } = this.state;
    const submenuItems = _.countBy(moreTabItems.items, 'group');

    const taggedItems = _.each(moreTabItems.items, item => {
      const isSubmenu = !_.isEmpty(item.group) && submenuItems[item.group] > 1;
      _.assign(item, {
        name: isSubmenu ? this.handleGroupName(item.group) : item.name,
        isSubmenu,
      });
    });

    const tabItems = _.assign(moreTabItems, {
      items: taggedItems,
    });

    return this.createTabs(tabItems, true);
  }

  render() {
    const { isPersonality } = this.props;
    const {
      moreTabItems: { items: moreItems },
    } = this.state;
    const tabRowClasses = isPersonality ? [Style.singleOptionTabRow] : [Style.tabRow];
    if (!_.isEmpty(moreItems)) tabRowClasses.push(Style.moreSpacer);
    const shouldRenderMoreDropdown = !!this.tabRow && this.getClipping();

    return (
      <div
        className={Style.tabRowWrapper}
        ref={el => {
          this.tabRow = el;
        }}
      >
        <div className={classNames(tabRowClasses)}>{this.renderCurrentDropdowns()}</div>
        <div className={Style.moreTab}>{shouldRenderMoreDropdown && this.renderMoreDropdown()}</div>
      </div>
    );
  }
}

TabListMobile.defaultProps = {
  overlay: null,
  tabIndex: false,
  pageId: null,
  isPersonality: false,
};

TabListMobile.propTypes = {
  overlay: PropTypes.string,
  setOverlay: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tabIndex: PropTypes.number,
  pageId: PropTypes.string,
  isPersonality: PropTypes.bool,
};

TabListMobile.contextTypes = {
  location: PropTypes.shape({}),
};

export default TabListMobile;
